<template lang="html">
  <div>
    <h3>Embed tool</h3>
    <b-row>
      <b-col class="mt-3">
        <h5>Responsive embed code</h5>
        <b-form-textarea
          id="textarea"
          v-model="embed_code_responsive"
          rows="6"
          max-rows="6"
          size="sm"
          @focus.native="$event.target.select()"
        />
        <p class="mt-1">
          <b-btn size="sm" @click="copyResponsiveEmbedCode">
            Copy code <v-icon name="copy" />
          </b-btn>
        </p>

        <h5 class="mt-4">Exact embed code</h5>
        <b-form-textarea
          id="textarea"
          v-model="embed_code_exact"
          rows="4"
          max-rows="6"
          size="sm"
          @focus.native="$event.target.select()"
        />
        <b-row class="mt-2">
          <b-col>
            <b-form-group id="fieldset-width" description="Exact width.">
              <b-form-input id="input-width" v-model="width" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="fieldset-height" description="Exact height.">
              <b-form-input id="input-height" v-model="height" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-btn size="sm" @click="copyExactEmbedCode">
              Copy code <v-icon name="copy" />
            </b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <h5>Why are there two embed codes?</h5>

        <p>
          Responsive embed codes adjust to the size of the page when used in
          conjunction with a responsive page design. This style is preferred in
          most situations, but is not always supported by your web site.
        </p>
        <p>
          Constant-sized, or "exact" iframes will always display at one
          particular defined size.
          <mark>
            If your site is responsive and supports responsive iframes, you
            should use the responsive embed code. When in doubt, try the
            responsive code first.
          </mark>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import copy from "copy-to-clipboard";
export default {
  name: "ShowEmbed",
  data() {
    return {
      width: 800,
      height: 533,
      show: {},
      show_loaded: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    embed_code_exact() {
      return `<iframe src="https://play.soundslides.com/${this.id}/fill" width="${this.width}" height="${this.height}" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`;
    },
    embed_code_responsive() {
      return this.$store.getters["show/responsiveEmbedCode"];
    },
    aspect_padding_bottom() {
      return ((this.height / this.width) * 100).toFixed(2) + "%";
    }
  },
  methods: {
    copyResponsiveEmbedCode() {
      copy(this.embed_code_responsive, { format: "text/plain" });
      this.$store.dispatch("toastMessage", "Embed code copied.");
    },
    copyExactEmbedCode() {
      copy(this.embed_code_exact, { format: "text/plain" });
      this.$store.dispatch("toastMessage", "Embed code copied.");
    }
  }
};
</script>

<style lang="css" scoped></style>
